export default __webpack_public_path__ + "static/media/SAL1.8fb8181c.jpg";